import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import OrgHeader from '../containers/orgs/OrgHeader';
import OrgList from '../containers/orgs/OrgList';


export default function(params) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <OrgHeader />
          <PageContentWrapper>
            <OrgList />
          </PageContentWrapper>
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
}
